import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routes } from './routing.urls';

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
